export default "__VITE_ASSET__CU0Al1bZ__"